
// // src/components/Login.js
// import React, { useState } from 'react';
// import authService from './services/authService';
// import { useAuth } from './AuthContext';
// import { Link, useNavigate } from 'react-router-dom';
// // import { FaUser, FaLock } from 'react-icons/fa';
// // import { ToastContainer, toast } from 'react-toastify';
// // import 'react-toastify/dist/ReactToastify.css';
// import '../App.css'; // Create and import a CSS file for styling
// import SessionNavbar from './SessionNavbar';

// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   const handleLogin = () => {
//     authService.login(username, password)
//       .then(response => {
//         login(response);
//         var user_name = localStorage.getItem('username');
//         <SessionNavbar  user={user_name}  />
//         navigate("/");    
//       })
//       .catch(error => {
//         console.log("logout successfully");
//         // toast.error('Login failed');
//       });
//   };

//   return (
//     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width:"100vw", height:"100vh" }}>
//     <div className="login-container">
//     <div><h4 style={{color: "white", fontWeight:"bolder"}}>Welcome to <br/> Sir Syed Educational Institutes</h4></div>
//        <div className='pb-5 pt-3'>
//        <img 
//         style={{ width: '150px' }} 
//         src={`http://147.93.104.16:4002/all_images/logo.jpeg`} 
//         alt="Logo" 
//       />

//       </div>
//       <div className="input-container">
//         {/* <FaUser /> */}
//         <input
//           type="text"
//           placeholder="Type your username"
//           onChange={(e) => setUsername(e.target.value)}
//         />
//       </div>
//       <div className="input-container">
//         {/* <FaLock /> */}
//         <input
//           type="password"
//           placeholder="Type your password"
//           onChange={(e) => setPassword(e.target.value)}
//         />
//       </div>
//       <button onClick={handleLogin} className="btn btn-sm btn-warning">LOGIN</button>
//       <div>
//         <div style={{"marginTop" : "20px", "color" : "white"}}><h5>©2025 Admin Panel DEVELOPED BY <a href="https://zeetechservices4u.blogspot.com" target='_blank'>ZeeTech Services</a></h5></div>
//       {/* <label className='mt-5'><Link to="/register-sses-user"  style={{color:'black'}}>for registeration click here?</Link></label> */}
//       </div>
//       {/* <div className="social-login">
//         <p>Or Sign Up Using</p>
//         <div className="social-icons">
//           <a href="#"><i className="fab fa-facebook-f"></i></a>
//           <a href="#"><i className="fab fa-twitter"></i></a>
//           <a href="#"><i className="fab fa-google"></i></a>
//         </div>
//       </div> */}
//       {/* <div className="sign-up">
//         <p>Or Sign Up Using</p>
//         <a href="#">SIGN UP</a>
//       </div> */}
//       {/* <ToastContainer /> */}
//     </div>
    
//     </div>
//   );
// };

// export default Login;


// src/components/Login.js
import React, { useState } from 'react';
import authService from './services/authService';
import { useAuth } from './AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import '../App.css';
import SessionNavbar from './SessionNavbar';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    setIsLoading(true);
    setError('');
    authService.login(username, password)
      .then(response => {
        login(response);
        var user_name = localStorage.getItem('username');
        navigate("/");
      })
      .catch(error => {
        setError('Invalid username or password.');
        setIsLoading(false);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&family=Lato:wght@300;400;700&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .peisctl-root {
          min-height: 100vh;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;
          background-color: #065f46;
          font-family: Nunito,sans-serif !important;
        }

        .peisctl-card {
          width: 100%;
          max-width: 420px;
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: clamp(2rem, 6vw, 3rem) clamp(1.5rem, 5vw, 2.5rem);
          backdrop-filter: blur(20px);
          box-shadow: 0 8px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255,255,255,0.04) inset;
          animation: cardIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
        }

        @keyframes cardIn {
          from { opacity: 0; transform: translateY(28px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        .peisctl-brand {
          text-align: center;
          margin-bottom: 2rem;
        }

        .peisctl-logo-text {
          font-family: 'Cinzel', serif;
          font-size: clamp(2rem, 7vw, 2.8rem);
          font-weight: 900;
          letter-spacing: 0.08em;
          line-height: 1;
          background: white;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: none;
        }

        .peisctl-subtitle {
          margin-top: 0.5rem;
          font-size: 0.72rem;
          font-weight: 300;
          letter-spacing: 0.3em;
          text-transform: uppercase;
          color: white;
        }

        .peisctl-divider {
          width: 48px;
          height: 2px;
          margin: 1.2rem auto 0;
          background: linear-gradient(90deg, transparent, #c9973a, transparent);
          border: none;
        }

        .peisctl-welcome {
          text-align: center;
          margin-bottom: 1.8rem;
        }

        .peisctl-welcome h4 {
          font-size: clamp(0.85rem, 2.5vw, 0.95rem);
          font-weight: 400;
          color: white;
          letter-spacing: 0.05em;
          line-height: 1.6;
        }

        .peisctl-field {
          margin-bottom: 1rem;
        }

        .peisctl-field label {
          display: block;
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: white;
          margin-bottom: 0.45rem;
        }

        .peisctl-field input {
          width: 100%;
          padding: 0.75rem 1rem;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 8px;
          color: #fff;
          font-family: Nunito,sans-serif !important;
          font-size: 0.95rem;
          font-weight: 300;
          outline: none;
          transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
        }

        .peisctl-field input::placeholder {
          color: rgba(255,255,255,0.2);
        }

        .peisctl-field input:focus {
          border-color: rgba(201, 151, 58, 0.6);
          background: rgba(255,255,255,0.09);
          box-shadow: 0 0 0 3px rgba(201, 151, 58, 0.1);
        }

        .peisctl-error {
          font-size: 0.78rem;
          color: #f87171;
          text-align: center;
          margin-bottom: 1rem;
          background: rgba(248, 113, 113, 0.08);
          border: 1px solid rgba(248, 113, 113, 0.2);
          border-radius: 6px;
          padding: 0.5rem 0.75rem;
        }

        .peisctl-btn {
          width: 100%;
          padding: 0.85rem;
          margin-top: 0.5rem;
          background: white;
          background-size: 200% 100%;
          background-position: left;
          border: none;
          border-radius: 8px;
          color: #1a0f00;
          font-family: 'Cinzel', serif;
          font-size: 0.85rem;
          font-weight: 700;
          letter-spacing: 0.2em;
          cursor: pointer;
          transition: background-position 0.4s ease, transform 0.15s, box-shadow 0.2s;
          box-shadow: 0 4px 20px rgba(201, 151, 58, 0.3);
        }

        .peisctl-btn:hover:not(:disabled) {
          background-position: right;
          transform: translateY(-1px);
          box-shadow: 0 6px 28px rgba(201, 151, 58, 0.45);
        }

        .peisctl-btn:active:not(:disabled) {
          transform: translateY(0);
        }

        .peisctl-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .peisctl-footer {
          text-align: center;
          margin-top: 1.8rem;
          padding-top: 1.4rem;
          border-top: 1px solid rgba(255,255,255,0.07);
        }

        .peisctl-footer p {
          font-size: 0.7rem;
          color: rgba(255,255,255,0.25);
          letter-spacing: 0.05em;
          line-height: 1.8;
        }

        .peisctl-footer a {
          color: #e8c97e;
          text-decoration: none;
          transition: color 0.2s;
        }

        .peisctl-footer a:hover {
          color: #e8c97e;
        }

        @media (max-width: 480px) {
          .peisctl-card {
            border-radius: 12px;
          }
        }
      `}</style>

      <div className="peisctl-root">
        <div className="peisctl-card">

          {/* Brand */}
          <div className="peisctl-brand">
            <div className="peisctl-logo-text">PEISCTL</div>
            <div className="peisctl-subtitle">Admin Portal</div>
            <hr className="peisctl-divider" />
          </div>

          {/* Welcome */}
          <div className="peisctl-welcome">
            <h4>Sign in to your account</h4>
          </div>

          {/* Fields */}
          <div className="peisctl-field">
            <label>Username</label>
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="username"
            />
          </div>

          <div className="peisctl-field">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="peisctl-error">{error}</div>}

          <button
            className="peisctl-btn"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'SIGNING IN...' : 'LOGIN'}
          </button>

          {/* Footer */}
          <div className="peisctl-footer">
            <p>
              © 2026 PEISCTL Admin Panel<br />
              Developed by{' '}
              <a href="https://zeetechservices4u.blogspot.com" target="_blank" rel="noreferrer">
                ZeeTech Services 4u
              </a>
            </p>
          </div>

        </div>
      </div>
    </>
  );
};

export default Login;